import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-4" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-4" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "col-lg-4" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "text-danger" }
const _hoisted_26 = { class: "col-lg-4" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = { class: "col-lg-12" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "text-danger" }
const _hoisted_34 = {
  type: "submit",
  class: "btn btn-primary"
}

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref, watch } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { formatDate, mapOptionMultiselect } from "@/utils/helper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { toast } from "vue-sonner";
import { useCategoryStore } from "@/stores/master/category-store";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { usePortStore } from "@/stores/master/port";
import { db } from "@/database/db";
import {
  RequisitionPayload,
  RequisitionResponse,
} from "@/types/interface/requisition";
import { useRequisitionStore } from "@/stores/management/requisition";
import Swal from "sweetalert2";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateForm',
  setup(__props) {

const idRequisition = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const requisitionStore = useRequisitionStore();
const categoryStore = useCategoryStore();
const groupCategoryStore = useCategoryGroupStore();
const portStore = usePortStore();
const listCategory = ref<any>([]);
const listGroupCategory = ref<any>([]);
const listPort = ref<any>([]);
const modalShow = ref<any>(false);
const queryTemp = ref<any>("");
const showProductForm = ref(false);
const requisitionDetail = ref<RequisitionResponse>();
const requisitionId = ref<number>();
let modalInstance: any;

const listUrgency = [
  { value: 1, label: "Regular" },
  { value: 2, label: "Urgent" },
];

const validationSchema = toTypedSchema(
  zod.object({
    vessel: zod.string().nonempty({ message: "Vessel is required" }),
    port: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    date: zod.string().nonempty({ message: "Date is required" }),
    category: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    group_category: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    urgency: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    remark: zod.string().nonempty({ message: "Remark is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: vessel } = useField<string>("vessel");
const { value: port } = useField<string>("port");
const { value: date } = useField<string>("date");
const { value: category } = useField<string>("category");
const { value: group_category } = useField<string>("group_category");
const { value: urgency } = useField<number>("urgency");
const { value: remark } = useField<string>("remark");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const requisitionPayload: RequisitionPayload = {
    port_id: port.value?.value,
    category_id: category.value?.value,
    group_category_id: group_category.value?.value,
    created_at: date.value,
    remarks: remark.value,
    priority: urgency.value?.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await requisitionStore.dispatchUpdate(
      idRequisition.value,
      requisitionPayload
    );
  } else {
    responseApi.value = await requisitionStore.dispatchCreate(
      requisitionPayload
    );
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    requisitionId.value = requisitionStore?.requisition?.data?.id;
    await db.requisition.put({
      requisition_id: requisitionId.value,
    });
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Requisition Successfully Updated"
          : "Requisition Successfully Added"
      );
      showProductForm.value = true;
      router.push("/management/requisition/add/" + requisitionId.value);
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});
const loadPort = async (query: string) => {
  let queryParam = "&keyword=" + query;
  const { success, message } = await portStore.dispatchGetAll(
    1,
    10,
    queryParam
  );
  if (success) {
    listPort.value = mapOptionMultiselect(
      await portStore.ports?.items,
      "id",
      "name",
      "country"
    );
  }
};

const loadCategory = async () => {
  const { success, message } = await categoryStore.dispatchGetCategories(1, 99);
  if (success) {
    listCategory.value = mapOptionMultiselect(
      await categoryStore.categories?.items,
      "id",
      "name"
    );
  }
};

const loadGroupCategory = async (idCategory = "") => {
  if (idCategory != "") {
    queryTemp.value = "&category_id=" + idCategory;
  }
  const { success, message } =
    await groupCategoryStore.dispatchGetCategoryGroups(1, 99, queryTemp.value);
  if (success) {
    listGroupCategory.value = mapOptionMultiselect(
      await groupCategoryStore.categoryGroups?.items,
      "id",
      "name"
    );
  }
};

const loadUserLogin = async () => {
  let getDataLogin = await db.storage.get("login-info");
  let userLogin = getDataLogin?.data;
  vessel.value = `${userLogin?.vessel?.name} (${userLogin?.vessel?.call_sign})`;
};

const handleSelectCategory = async () => {
  await loadGroupCategory(category.value?.value);
};

let debounceTimeoutPort: any;

const handleSearchPort = (query: string) => {
  clearTimeout(debounceTimeoutPort);
  debounceTimeoutPort = setTimeout(() => {
    loadPort(query);
  }, 500);
};

const loadRequisition = async () => {
  const { success, message } = await requisitionStore.dispatchDetail(
    idRequisition.value
  );
  if (success) {
    requisitionDetail.value = requisitionStore?.requisition?.data;
    category.value = mapOptionMultiselect(requisitionDetail.value.category);
    group_category.value = mapOptionMultiselect(
      requisitionDetail.value.groupCategory
    );
    port.value = mapOptionMultiselect(requisitionDetail.value.port);
    date.value = formatDate(requisitionDetail.value.created_at);
    requisitionId.value = requisitionDetail.value.id;
    remark.value = requisitionDetail.value.remarks;
    urgency.value = { value: requisitionDetail.value.priority_id, label: requisitionDetail.value.priority.toString() };
    showProductForm.value = true;
  }
};

onMounted(() => {
  loadCategory();
  loadGroupCategory();
  loadPort("");
  loadUserLogin();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idRequisition.value = router.currentRoute.value.params.id.toString();
    loadRequisition();
  }
});

const backToListRequisition = () => {
  handleBeforeReloadModal("/management/requisition");
};

const handleBeforeReloadModal = (to: any) => {
  Swal.fire({
    title: "Are you sure want to leave requisition page ?",
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: "Yes",
    denyButtonText: `No`,
    text: "All data will deleted, unless you already save before",
  }).then((result) => {
    if (result.isConfirmed) {
      router.push(to);
    }
  });
};

watch(modalShow, (newVal) => {
  if (modalInstance) {
    if (newVal) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "mb-0" }, "Form Create Requisition", -1)),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              onClick: backToListRequisition
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }, null, -1),
              _createTextVNode(" Back To List Requisition ")
            ]))
          ]),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", {
                        for: "vessel",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Vessel "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "vessel",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(vessel) ? (vessel).value = $event : null)),
                          placeholder: "Vessel",
                          type: "text",
                          class: "form-control text-dark",
                          readonly: ""
                        }, null, 512), [
                          [_vModelText, _unref(vessel)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).vessel), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", {
                        for: "port",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Port "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(port),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(port) ? (port).value = $event : null)),
                          options: listPort.value,
                          placeholder: "Choose Port",
                          onSearch: handleSearchPort
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).port), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        for: "date",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Date Receipt "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          name: "date",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(date) ? (date).value = $event : null)),
                          placeholder: "Date Receipt",
                          type: "date",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(date)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).date), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", {
                        for: "category",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Category "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(category),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(category) ? (category).value = $event : null)),
                          options: listCategory.value,
                          placeholder: "Choose Category",
                          onClose: handleSelectCategory
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).category), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", {
                        for: "group_category",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Group Category "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(group_category),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(group_category) ? (group_category).value = $event : null)),
                          options: listGroupCategory.value,
                          placeholder: "Choose Group Category"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(errors).group_category), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        for: "urgency",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Urgency "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(urgency),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(urgency) ? (urgency).value = $event : null)),
                          options: listUrgency,
                          placeholder: "Choose Urgency"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(errors).urgency), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", {
                        for: "remark",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Remark "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("textarea", {
                          name: "remark",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(remark) ? (remark).value = $event : null)),
                          placeholder: "Remark",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(remark)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(errors).date), 1)
                    ])
                  ])
                ]),
                _createElementVNode("button", _hoisted_34, _toDisplayString(isEdit.value ? "Update Form Requisition" : "Create Form Requisition"), 1)
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})